import React, {useState} from "react";
import Chart from "react-apexcharts";
import moment from "moment";

const AreaChart = ({data = [], colors = ["#3f51b5"]}) => {
  const [range, setRange] = useState({min: 0, max: 40});

  // Set time range: last 24 hours
  const endTime = moment();
  const startTime = moment().subtract(24, "hours");

  const handleZoom = (chartContext, {xaxis}) => {
    setRange({min: xaxis.min, max: xaxis.max});
  };
  // Generate default data if empty
  if (data.length === 0) {
    const now = moment();
    data = Array.from({length: 5}, (_, i) => ({
      dateCreated: now.clone().subtract(4 - i, "minutes").toISOString(), // Subtract minutes
      duration: 0, // Default value
    }));
  }
  // Sort data by dateCreated (oldest to newest)
  const sortedData = [...data].sort((a, b) => {
    return new Date(a.dateCreated) - new Date(b.dateCreated);
  });

  // Extract x (time) and y (values), filtering out 0 values
  let seriesData = sortedData.map((item) => ({
    x: item.dateCreated, //moment(item.dateCreated).format("ddd HH:mm"), // Format time
    y: item.duration,
  }));

  // Ensure min value is -1 if all values are 0 or empty
  const hasNonZeroValues = data.length > 0;
  const minY = hasNonZeroValues ? undefined : -1;

  // const maxY = hasNonZeroValues ? undefined : 1;

  const options = {
    chart: {
      type: "area",
      height: 170,
      toolbar: {show: true},
      zoom: {
        enabled: true,
        type: "x",
      },
      events: {
        zoomed: handleZoom,
      },
    },
    xaxis: {
      type: "datetime",
      min: startTime ? startTime.valueOf() : undefined,
      max: endTime ? endTime.valueOf() : undefined,
      labels: {show: false},
      axisBorder: {show: false},
      axisTicks: {show: false},
    },
    yaxis: {
      min: minY,
      // max: maxY,
      labels: {show: false}, // Hide Y-axis labels
    },
    fill: {
      type: "gradient",
      gradient: {shadeIntensity: 0.1, opacityFrom: 0.9, opacityTo: 0.15},
    },
    colors,
    grid: {show: false},
    stroke: {curve: "smooth"},
    dataLabels: {enabled: false}, // Hide value labels on chart
    tooltip: {
      custom: function ({series, seriesIndex, dataPointIndex, w}) {
        const dataPoint = sortedData[dataPointIndex];
        if (!dataPoint || dataPoint.duration === null) {
          return `
            <div style="padding: 10px; background: white; border: 1px solid #e0e0e0; border-radius: 5px;">
              <div style="font-weight: 600; color: #999;">No data</div>
            </div>
          `;
        }

        const timestamp = dataPoint.timestamp;
        const formattedDate = moment(timestamp).format("DD MMM YYYY HH:mm");

        return `
          <div style="padding: 10px; background: white; border: 1px solid #e0e0e0; border-radius: 5px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
            <div style="font-weight: 600; margin-bottom: 8px; color: #333;">${formattedDate}</div>
            <div style="color: #666; font-size: 13px;">Duration: <strong>${dataPoint.duration}</strong></div>
          </div>
        `;
      }
    },
  };

  return <Chart options={options} series={[{name: "Duration", data: seriesData}]} type="area" height={140}
                width={"100%"}/>;
};

export default AreaChart;
